var sandwich = [
    {
        "id": "31",
        "name": "Carrozza Cemita Pomodoro",
        "category": "sandwich",
        "img": "https://i.imgur.com/0WwLSB4.png",
        "description": "how we dream about our future",
        "story": "Food is any substance consumed to provide nutritional support for an organism. Food is usually of plant or animal origin, and contains essential nutrients, such as carbohydrates, fats, proteins, vitamins, or minerals.",
        "price": 3.99
    },
    {
        "id": "32",
        "name": "Broodje kroket Beef",
        "category": "sandwich",
        "img": "https://i.imgur.com/UsKSvmL.png",
        "description": "how we dream about our future",
        "story": "Food is any substance consumed to provide nutritional support for an organism. Food is usually of plant or animal origin, and contains essential nutrients, such as carbohydrates, fats, proteins, vitamins, or minerals.",
        "price": 4.99
    },
    {
        "id": "33",
        "name": "Bratwurst Lasagana Chicken",
        "category": "sandwich",
        "img": "https://i.imgur.com/2NyAOaQ.png",
        "description": "how we dream about our future",
        "story": "Food is any substance consumed to provide nutritional support for an organism. Food is usually of plant or animal origin, and contains essential nutrients, such as carbohydrates, fats, proteins, vitamins, or minerals.",
        "price": 6.99
    },
    {
        "id": "34",
        "name": "Parmigana Al Forno",
        "category": "sandwich",
        "img": "https://i.imgur.com/9TSlux1.png",
        "description": "how we dream about our future",
        "story": "Food is any substance consumed to provide nutritional support for an organism. Food is usually of plant or animal origin, and contains essential nutrients, such as carbohydrates, fats, proteins, vitamins, or minerals.",
        "price": 4.99
    },
    {
        "id": "35",
        "name": "Panini Pollo Mexicana",
        "category": "sandwich",
        "img": "https://i.imgur.com/ocoGRN4.png",
        "description": "how we dream about our future",
        "story": "Food is any substance consumed to provide nutritional support for an organism. Food is usually of plant or animal origin, and contains essential nutrients, such as carbohydrates, fats, proteins, vitamins, or minerals.",
        "price": 5.99
    },
    {
        "id": "36",
        "name": "Paino Americano Fry",
        "category": "sandwich",
        "img": "https://i.imgur.com/0nLr9NI.png",
        "description": "how we dream about our future",
        "story": "Food is any substance consumed to provide nutritional support for an organism. Food is usually of plant or animal origin, and contains essential nutrients, such as carbohydrates, fats, proteins, vitamins, or minerals.",
        "price": 6.99
    },


]
export default sandwich;